module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_mobile_5-dc9922a7a5cd4597d4a1eabc05e395f2.png";